import { lazy } from "react"
export const RouteConfig = [
    {
        component: lazy(() => import("./containers/PageContainer")),
        path: "/*"
    },
    {
        component: lazy(() => import("./containers/PageContainer")),
        path: "*"
    }
]